var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "sb-global-dropdown",
      class: [
        {
          "is-open": _vm.isOpen,
          "is-disabled": _vm.disabled,
          "is-full-width": _vm.fullWidth
        },
        _vm.triggerVariantClass
      ],
      style: _vm.rootStyles
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "sb-global-dropdown__trigger",
          class: [_vm.sizeClass, _vm.triggerVariantClass, _vm.triggerClass],
          attrs: {
            id: _vm.triggerId,
            type: "button",
            disabled: _vm.isTriggerDisabled,
            "aria-expanded": _vm.isOpen.toString(),
            "aria-controls": _vm.dropdownId + "-panel",
            "aria-haspopup": "listbox",
            "aria-activedescendant": _vm.activeDescendant
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleDropdown($event)
            },
            keydown: _vm.onTriggerKeydown
          }
        },
        [
          _c("span", { staticClass: "sb-global-dropdown__label" }, [
            _vm._v("\n      " + _vm._s(_vm.displayLabel) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sb-global-dropdown__chevron",
              attrs: { "aria-hidden": "true" }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }
                },
                [
                  _c("polyline", {
                    attrs: {
                      points: "6 9 12 15 18 9",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen"
            }
          ],
          ref: "panel",
          staticClass: "sb-global-dropdown__panel",
          class: _vm.panelClass,
          style: _vm.mergedPanelStyles,
          attrs: {
            id: _vm.dropdownId + "-panel",
            role: "listbox",
            tabindex: "-1"
          },
          on: {
            mousedown: function($event) {
              $event.stopPropagation()
            },
            touchstart: function($event) {
              $event.stopPropagation()
            },
            click: function($event) {
              $event.stopPropagation()
            },
            keydown: _vm.onMenuKeydown
          }
        },
        [
          !_vm.options.length
            ? _c(
                "li",
                {
                  staticClass:
                    "sb-global-dropdown__option is-disabled is-empty",
                  attrs: {
                    role: "option",
                    "aria-selected": "false",
                    "aria-disabled": "true"
                  }
                },
                [_vm._v("\n      No Data Available\n    ")]
              )
            : _vm._l(_vm.options, function(option, index) {
                return _c(
                  "li",
                  {
                    key: option.id || _vm.dropdownId + "-" + index,
                    ref: "optionNodes",
                    refInFor: true,
                    staticClass: "sb-global-dropdown__option",
                    class: {
                      "is-selected": _vm.value === option.value,
                      "is-focused": _vm.focusedIndex === index,
                      "is-disabled": option.disabled
                    },
                    attrs: {
                      id: _vm.getOptionId(index),
                      role: "option",
                      "aria-selected": (_vm.value === option.value).toString(),
                      "aria-disabled": !!option.disabled
                    },
                    on: {
                      mouseenter: function($event) {
                        return _vm.onOptionMouseEnter(index)
                      },
                      mousedown: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                      },
                      touchstart: function($event) {
                        $event.stopPropagation()
                      },
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.selectOptionByIndex(index)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
                )
              })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }